// extracted by mini-css-extract-plugin
module.exports = {"detailItemList":"DetailItemList_detailItemList__3M-o0","quoteDetailItem":"DetailItemList_quoteDetailItem__1cYZM"};